import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var lengthOptionsIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.509.25a.762.762 0 0 1 .751.752c0 .932.07 2.29.17 3.853.212 3.37.535 8.143.551 17.035V23a.76.76 0 0 1-.75.75H9.46a.75.75 0 0 1-.742-.63L7.496 10.093v.03L6.233 23.12a.75.75 0 0 1-.741.63h-3.74A.76.76 0 0 1 1 23c0-9.61.34-14.638.561-18.145.1-1.563.17-2.921.17-3.853A.762.762 0 0 1 2.484.25Zm8.206.296 2.822 2.822-.353.354c-.354.354-1.06.354-1.414 0l-1.02-1.02v18.594l1.02-1.02c.324-.323.945-.35 1.318-.08l.096.08.353.354-2.822 2.823a1.011 1.011 0 0 1-1.334.084l-.095-.084-2.823-2.823.355-.355c.325-.328.955-.35 1.328-.074l.088.076 1.016 1.015V2.706l-1.016 1.016c-.353.354-1.064.357-1.416.002l-.355-.355L19.286.546a1.01 1.01 0 0 1 1.429 0ZM11.917 4.75H3.044v.205c-.22 3.387-.56 8.206-.56 17.295H4.88L6.003 9.852a1.583 1.583 0 0 1 1.493-1.403c.75.034 1.375.59 1.493 1.333l1.122 12.468h2.368c-.02-9.09-.341-13.908-.562-17.295V4.75Zm-.15-2.997H3.225c-.01.391-.06 1.037-.06 1.498h8.662c-.06-.46-.06-1.107-.06-1.498Z",
  fill: "currentColor"
}));

export { lengthOptionsIcon as default };
//# sourceMappingURL=lengthOptionsIcon.js.map
